import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
  MobileCard,
  MobileCardRow,
  MobileCardLabel,
  MobileCardValue,
  MobileCardActions,
} from 'components/tanstack-table/styles';
import {
  DOCUMENTS__DOCUMENT_CATEGORY,
  DOCUMENTS__PERIOD_START,
  DOCUMENTS__PERIOD_END,
  DOCUMENTS__EMPLOYEE,
} from 'translations/constants';
import { IViewDocument } from 'types/documents/IDocument';
import { ReactComponent as DeleteIcon } from '../../assets/icons/DeleteGrey.svg';
import { ReactComponent as DocumentIcon } from '../../assets/icons/DocumentGridIcon.svg';
import { ReactComponent as DownloadIcon } from '../../assets/icons/DownloadGrey.svg';

interface DocumentMobileCardProps {
  row: IViewDocument;
  userCanDownload: (id: number) => boolean;
  userCanDelete: (id: number) => boolean;
  onDownload: (id: number) => void;
  onDelete: (id: number) => void;
  actions: React.ReactNode;
  checkbox: React.ReactNode;
  isSelected: boolean;
}

export const DocumentMobileCard = ({
  row,
  actions,
  checkbox,
  isSelected,
  userCanDownload,
  userCanDelete,
  onDownload,
  onDelete,
}: DocumentMobileCardProps): JSX.Element => {
  const [t] = useTranslation();

  return (
    <MobileCard isSelected={isSelected}>
      <Box display="flex" justifyContent="space-between" alignItems="flex-start" gap={1} mb={1}>
        <Box display="flex" alignItems="center" gap={1} flex={1} minWidth={0}>
          <DocumentIcon style={{ width: '24px', height: '24px', flexShrink: 0 }} />
          <MobileCardValue sx={{ fontWeight: 600, wordBreak: 'break-word' }}>{row.name}</MobileCardValue>
        </Box>
        {checkbox && (
          <Box flexShrink={0} pt={0.5}>
            {checkbox}
          </Box>
        )}
      </Box>
      <MobileCardRow>
        <MobileCardLabel>{t(DOCUMENTS__DOCUMENT_CATEGORY)}:</MobileCardLabel>
        <MobileCardValue>{row.categoryName}</MobileCardValue>
      </MobileCardRow>
      <MobileCardRow>
        <MobileCardLabel>{t(DOCUMENTS__PERIOD_START)}:</MobileCardLabel>
        <MobileCardValue>{row.periodStart}</MobileCardValue>
      </MobileCardRow>
      <MobileCardRow>
        <MobileCardLabel>{t(DOCUMENTS__PERIOD_END)}:</MobileCardLabel>
        <MobileCardValue>{row.periodEnd}</MobileCardValue>
      </MobileCardRow>
      {row.employeeName && (
        <MobileCardRow>
          <MobileCardLabel>{t(DOCUMENTS__EMPLOYEE)}:</MobileCardLabel>
          <MobileCardValue>{row.employeeName}</MobileCardValue>
        </MobileCardRow>
      )}
      <MobileCardActions>
        <Box display="flex" alignItems="center" gap={1.5}>
          {userCanDownload(row.id) && (
            <DownloadIcon className="documentsIcon" onClick={() => onDownload(row.id)} style={{ cursor: 'pointer' }} />
          )}
          {userCanDelete(row.id) && (
            <DeleteIcon className="documentsIcon" onClick={() => onDelete(row.id)} style={{ cursor: 'pointer' }} />
          )}
        </Box>
        {actions}
      </MobileCardActions>
    </MobileCard>
  );
};

export default DocumentMobileCard;
